<template>
    <svg
        width="7"
        height="12"
        viewBox="0 0 7 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            :fill="customColor"
            d="M6.74815 6.59406L1.46799 11.7537C1.1321 12.0821 0.587529 12.0821 0.25181 11.7537C-0.0839366 11.4256 -0.0839366 10.8935 0.25181 10.5654L4.92394 5.99991L0.251946 1.43457C-0.0838007 1.10635 -0.0838007 0.574263 0.251946 0.24617C0.587692 -0.0820565 1.13224 -0.0820565 1.46812 0.24617L6.74829 5.4059C6.91616 5.57002 7 5.7849 7 5.99989C7 6.21498 6.916 6.43002 6.74815 6.59406Z"
        />
    </svg>
</template>

<script setup lang="ts">
    import { DEFAULT_BUTTON_COLOR } from '~/utils/constants';

    defineProps({
        customColor: {
            type: String,
            required: false,
            default: DEFAULT_BUTTON_COLOR
        }
    });
</script>
